import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean {
    const platform = Capacitor.getPlatform();

    if (platform === 'web') {
      return true;
    }

    this.router.navigate(['stepper']);
    return false;
  }
}
